
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as carto17Hk3H3NYEO_45FFdaJOjgwf0g_fC_a17YdUdJaFSiRYMeta } from "/vercel/path0/pages/cart.vue?macro=true";
import { default as debugI_45QvvWa932qo4ck4pkKimMLzswQoFM11sIHH7JqcxboMeta } from "/vercel/path0/pages/debug.vue?macro=true";
import { default as fontsQyRA_45bOCnpoKImPzmacpl6kIL9zExQCC_45_457KUBNnkJkMeta } from "/vercel/path0/pages/fonts.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as searchE0nZQqeAMWsUG5cnJAPfFVP401IiagPhLDCR_YaJLbcMeta } from "/vercel/path0/pages/search.vue?macro=true";
import { default as login9kNGJYnegq8rWk72uRK_bV6k6oZIODiWnCUd95wPiW4Meta } from "/vercel/path0/pages/account/login.vue?macro=true";
import { default as resetGkm6G6JGkq8AIWMDdgerJbOcZ7u9JFzDdga5IVyVNakMeta } from "/vercel/path0/pages/account/reset.vue?macro=true";
import { default as register7Tjc55n9YUIJjpL51GQHBjWB4hhxDCOBpqmuCiBd5mUMeta } from "/vercel/path0/pages/account/register.vue?macro=true";
import { default as _91id_93eTmlZQh2q_U5QbrbhIh5K07fli5MdqDHaDqYhxgd9hYMeta } from "/vercel/path0/pages/account/orders/[id].vue?macro=true";
import { default as verifyEmaill6CvWZlT00d4DqM5YgHI_mxz8i7xFotrLjwIOwcDXk4Meta } from "/vercel/path0/pages/account/verifyEmail.vue?macro=true";
import { default as indexEN7UYhqJJNXclle_q__VPMBQKZZ_45XwL0cMSTDmGvLi4Meta } from "/vercel/path0/pages/account/orders/index.vue?macro=true";
import { default as indexb3R29QQT1_458_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta } from "/vercel/path0/pages/account/courses/index.vue?macro=true";
import { default as passwordReset9yTTYS8QeaDjEKZOTN_45MDVNM996BdV9qKdCalMXJxk4Meta } from "/vercel/path0/pages/account/passwordReset.vue?macro=true";
import { default as index9M_4SjD6JJRIjIomh2dVPamwoa4nPruTKRRwCm7RL0EMeta } from "/vercel/path0/pages/account/exercises/index.vue?macro=true";
import { default as detailsEeXzz4LwS2gn5AEp0mDeM25DF7OJDakJ96TV9ZDLt8AMeta } from "/vercel/path0/pages/account/profile/details.vue?macro=true";
import { default as addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_45GNqbPBrwgMMeta } from "/vercel/path0/pages/account/profile/addresses.vue?macro=true";
import { default as workoutsGjhMMTqMWDqKwYljSFD7LwB1meOyt3D0m2zk4uFUX_45UMeta } from "/vercel/path0/pages/account/exercises/workouts.vue?macro=true";
import { default as indexKS5_45OOeJTVrQsDSjAypHZaxUYs_Yi0jLC6GXDpv0zSsMeta } from "/vercel/path0/pages/account/exercises/premium/index.vue?macro=true";
import { default as _91slug_93AtkwgDCH4Jmo6OF_45W5gYKdVbNQ5qe3YagvKVXFZQM_454Meta } from "/vercel/path0/pages/account/exercises/premium/[slug].vue?macro=true";
import { default as account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta } from "/vercel/path0/pages/account.vue?macro=true";
import { default as _91_46_46_46slug_93eD0_45aLJH_SWaJVw5CBvPn8cEE2xWIMXlvr23TEyf8PMMeta } from "/vercel/path0/pages/[...slug].vue?macro=true";
import { default as processing8__AQ6w7Ayu7WO0Prm91p8NPwKXikt4klxL4K8zCquEMeta } from "/vercel/path0/pages/processing.vue?macro=true";
import { default as indexy4anpwv8RgJL1xsHEkIFeeBFrRfb2qJ9ikh9XD7CLAIMeta } from "/vercel/path0/pages/shop/index.vue?macro=true";
import { default as index8TnTrG1RLdezOSU25M4mZcfRoygosPx29K_45pj23ghrsMeta } from "/vercel/path0/pages/about/index.vue?macro=true";
import { default as _91slug_93zU8XLkEs0SNcqU8WVGHeEFcy_pU_454Tdxi_45ZvMJbUBYwMeta } from "/vercel/path0/pages/about/[slug].vue?macro=true";
import { default as _91slug_930uOZl0yqO05zRWaVCER1BTl48phPQtM4iBMk0CV_7mgMeta } from "/vercel/path0/pages/story/[slug].vue?macro=true";
import { default as index8pOPo_45MmsNeaNPH0Cac_45ENGuB554OoXgM_45UsG006imIMeta } from "/vercel/path0/pages/academy/index.vue?macro=true";
import { default as indexNdvo7eny1MAE_c_45BDueLRtPyossWin_45mbkbQVEtUn8kMeta } from "/vercel/path0/pages/experts/index.vue?macro=true";
import { default as indexJY4MRQvdhxPNoUF4AFllbL59PPwL7XMtczUcnCnal0IMeta } from "/vercel/path0/pages/returns/index.vue?macro=true";
import { default as labelHp6Q5Fllja8L_45cvDEWWYcTTT41p4c3FarEIEyjQ_45zWIMeta } from "/vercel/path0/pages/returns/label.vue?macro=true";
import { default as orderoSVPko7dj62xoQGx7sxX9_45hcmEIykFeLMAsvM9i7kloMeta } from "/vercel/path0/pages/returns/order.vue?macro=true";
import { default as indexJ2L_45Wnt3WpUkRvfOqtUguiqik3mLFBnVDTA_45TgWq4gQMeta } from "/vercel/path0/pages/stories/index.vue?macro=true";
import { default as _91slug_93pbL6ZPBg6ZvRiSesPc0Ko_mZVigAEBTPFioR0RN3G0sMeta } from "/vercel/path0/pages/routine/[slug].vue?macro=true";
import { default as _91slug_93ukb6ytBTIEUo5a7BP7KUuAjNmhZUtdyi2FtURUJxoX8Meta } from "/vercel/path0/pages/stories/[slug].vue?macro=true";
import { default as index16Ptkqjza7kOqLviXx5YfGY9MQEr9ZkCg9BQ_45VRXfmMMeta } from "/vercel/path0/pages/knowledge/index/index.vue?macro=true";
import { default as indexDuR1WHKmHggMj3TfC7pZhNu9Ma6cSH2G51wtQQjswT0Meta } from "/vercel/path0/pages/knowledge/index/[topic]/index.vue?macro=true";
import { default as _91slug_93AGgqVGveBpUbhXV8rx4_j4JDF_45hmTxyS4gwcxZbi2EMMeta } from "/vercel/path0/pages/knowledge/index/category/[slug].vue?macro=true";
import { default as articlesJ8TClYlYoivqOdk1mAcbMqI6pEm61rrdgxU8ObBrl7wMeta } from "/vercel/path0/pages/knowledge/index/[topic]/articles.vue?macro=true";
import { default as _91category_936nefCRDhebJyGrbtNKG_Bt9hy03IHimMFyYeGZ1OH2IMeta } from "/vercel/path0/pages/knowledge/index/[topic]/[category].vue?macro=true";
import { default as indexer6HU_HqrwSxRZpFVbIPTgveLDAY_45GxXiOdCB3_z2N4Meta } from "/vercel/path0/pages/knowledge/index.vue?macro=true";
import { default as _91slug_93_Yzn_45mcvpcrxbHQMkMS8QzhOlnl5r_Krv7P91fg9lGEMeta } from "/vercel/path0/pages/products/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93WNr4_Gd2TUxJfKSXYaKuSi_45_455S8E__iBrsIkkcKQ7U8Meta } from "/vercel/path0/pages/academy/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93_1s3vILwTOKB_rGOu_xQOL463cvZAj9spkLucYUBKx4Meta } from "/vercel/path0/pages/service/[...slug].vue?macro=true";
import { default as indexQ0SJA_457g2FqjeSUM0DJnjfsQPVrhP0Jvl2t4LliB5CEMeta } from "/vercel/path0/pages/shop/[slug]/index.vue?macro=true";
import { default as _91_46_46_46slug_93Al_NnYGJAh3gEgFl_45Sba2Mw7_0EFUK9ZjNNPa_45vTndoMeta } from "/vercel/path0/pages/exercises/[...slug].vue?macro=true";
import { default as indexk7oct_45Lb2qbJ7zK5YD91I2iKTWrk2KY1nFmakH6TaBMMeta } from "/vercel/path0/pages/article/[slug]/index.vue?macro=true";
import { default as indexOW4m65SdK4Rv4h82IBEG30CNqV7__45RSbVZDeRQ2MLvgMeta } from "/vercel/path0/pages/experts/[slug]/index.vue?macro=true";
import { default as indexPyMhLdUfWLX5lvqv3m_45NDoawgdNWkMc4t_451po3UO9roMeta } from "/vercel/path0/pages/collections/[handle]/index.vue?macro=true";
export default [
  {
    name: "cart___en",
    path: "/cart",
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "cart___de",
    path: "/de/cart",
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "cart___fr",
    path: "/fr/cart",
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "cart___nl",
    path: "/nl/cart",
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "cart___ch-de",
    path: "/ch-de/cart",
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "cart___ch-fr",
    path: "/ch-fr/cart",
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "debug___en",
    path: "/debug",
    component: () => import("/vercel/path0/pages/debug.vue")
  },
  {
    name: "debug___de",
    path: "/de/debug",
    component: () => import("/vercel/path0/pages/debug.vue")
  },
  {
    name: "debug___fr",
    path: "/fr/debug",
    component: () => import("/vercel/path0/pages/debug.vue")
  },
  {
    name: "debug___nl",
    path: "/nl/debug",
    component: () => import("/vercel/path0/pages/debug.vue")
  },
  {
    name: "debug___ch-de",
    path: "/ch-de/debug",
    component: () => import("/vercel/path0/pages/debug.vue")
  },
  {
    name: "debug___ch-fr",
    path: "/ch-fr/debug",
    component: () => import("/vercel/path0/pages/debug.vue")
  },
  {
    name: "fonts___en",
    path: "/fonts",
    component: () => import("/vercel/path0/pages/fonts.vue")
  },
  {
    name: "fonts___de",
    path: "/de/fonts",
    component: () => import("/vercel/path0/pages/fonts.vue")
  },
  {
    name: "fonts___fr",
    path: "/fr/fonts",
    component: () => import("/vercel/path0/pages/fonts.vue")
  },
  {
    name: "fonts___nl",
    path: "/nl/fonts",
    component: () => import("/vercel/path0/pages/fonts.vue")
  },
  {
    name: "fonts___ch-de",
    path: "/ch-de/fonts",
    component: () => import("/vercel/path0/pages/fonts.vue")
  },
  {
    name: "fonts___ch-fr",
    path: "/ch-fr/fonts",
    component: () => import("/vercel/path0/pages/fonts.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___ch-de",
    path: "/ch-de",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___ch-fr",
    path: "/ch-fr",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "search___nl",
    path: "/nl/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "search___ch-de",
    path: "/ch-de/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "search___ch-fr",
    path: "/ch-fr/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "account___en",
    path: "/account",
    meta: account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta || {},
    component: () => import("/vercel/path0/pages/account.vue"),
    children: [
  {
    name: "account-login___en",
    path: "login",
    component: () => import("/vercel/path0/pages/account/login.vue")
  },
  {
    name: "account-reset___en",
    path: "reset",
    component: () => import("/vercel/path0/pages/account/reset.vue")
  },
  {
    name: "account-register___en",
    path: "register",
    component: () => import("/vercel/path0/pages/account/register.vue")
  },
  {
    name: "account-orders-id___en",
    path: "orders/:id()",
    component: () => import("/vercel/path0/pages/account/orders/[id].vue")
  },
  {
    name: "account-verifyEmail___en",
    path: "verifyEmail",
    component: () => import("/vercel/path0/pages/account/verifyEmail.vue")
  },
  {
    name: "account-orders___en",
    path: "orders",
    meta: indexEN7UYhqJJNXclle_q__VPMBQKZZ_45XwL0cMSTDmGvLi4Meta || {},
    component: () => import("/vercel/path0/pages/account/orders/index.vue")
  },
  {
    name: "account-courses___en",
    path: "courses",
    meta: indexb3R29QQT1_458_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta || {},
    component: () => import("/vercel/path0/pages/account/courses/index.vue")
  },
  {
    name: "account-passwordReset___en",
    path: "passwordReset",
    component: () => import("/vercel/path0/pages/account/passwordReset.vue")
  },
  {
    name: "account-exercises___en",
    path: "exercises",
    component: () => import("/vercel/path0/pages/account/exercises/index.vue")
  },
  {
    name: "account-profile-details___en",
    path: "profile/details",
    component: () => import("/vercel/path0/pages/account/profile/details.vue")
  },
  {
    name: "account-profile-addresses___en",
    path: "profile/addresses",
    meta: addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_45GNqbPBrwgMMeta || {},
    component: () => import("/vercel/path0/pages/account/profile/addresses.vue")
  },
  {
    name: "account-exercises-workouts___en",
    path: "exercises/workouts",
    component: () => import("/vercel/path0/pages/account/exercises/workouts.vue")
  },
  {
    name: "account-exercises-premium___en",
    path: "exercises/premium",
    component: () => import("/vercel/path0/pages/account/exercises/premium/index.vue")
  },
  {
    name: "account-exercises-premium-slug___en",
    path: "exercises/premium/:slug()",
    component: () => import("/vercel/path0/pages/account/exercises/premium/[slug].vue")
  }
]
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta || {},
    component: () => import("/vercel/path0/pages/account.vue"),
    children: [
  {
    name: "account-login___de",
    path: "login",
    component: () => import("/vercel/path0/pages/account/login.vue")
  },
  {
    name: "account-reset___de",
    path: "reset",
    component: () => import("/vercel/path0/pages/account/reset.vue")
  },
  {
    name: "account-register___de",
    path: "register",
    component: () => import("/vercel/path0/pages/account/register.vue")
  },
  {
    name: "account-orders-id___de",
    path: "orders/:id()",
    component: () => import("/vercel/path0/pages/account/orders/[id].vue")
  },
  {
    name: "account-verifyEmail___de",
    path: "verifyEmail",
    component: () => import("/vercel/path0/pages/account/verifyEmail.vue")
  },
  {
    name: "account-orders___de",
    path: "orders",
    meta: indexEN7UYhqJJNXclle_q__VPMBQKZZ_45XwL0cMSTDmGvLi4Meta || {},
    component: () => import("/vercel/path0/pages/account/orders/index.vue")
  },
  {
    name: "account-courses___de",
    path: "courses",
    meta: indexb3R29QQT1_458_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta || {},
    component: () => import("/vercel/path0/pages/account/courses/index.vue")
  },
  {
    name: "account-passwordReset___de",
    path: "passwordReset",
    component: () => import("/vercel/path0/pages/account/passwordReset.vue")
  },
  {
    name: "account-exercises___de",
    path: "exercises",
    component: () => import("/vercel/path0/pages/account/exercises/index.vue")
  },
  {
    name: "account-profile-details___de",
    path: "profile/details",
    component: () => import("/vercel/path0/pages/account/profile/details.vue")
  },
  {
    name: "account-profile-addresses___de",
    path: "profile/addresses",
    meta: addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_45GNqbPBrwgMMeta || {},
    component: () => import("/vercel/path0/pages/account/profile/addresses.vue")
  },
  {
    name: "account-exercises-workouts___de",
    path: "exercises/workouts",
    component: () => import("/vercel/path0/pages/account/exercises/workouts.vue")
  },
  {
    name: "account-exercises-premium___de",
    path: "exercises/premium",
    component: () => import("/vercel/path0/pages/account/exercises/premium/index.vue")
  },
  {
    name: "account-exercises-premium-slug___de",
    path: "exercises/premium/:slug()",
    component: () => import("/vercel/path0/pages/account/exercises/premium/[slug].vue")
  }
]
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta || {},
    component: () => import("/vercel/path0/pages/account.vue"),
    children: [
  {
    name: "account-login___fr",
    path: "login",
    component: () => import("/vercel/path0/pages/account/login.vue")
  },
  {
    name: "account-reset___fr",
    path: "reset",
    component: () => import("/vercel/path0/pages/account/reset.vue")
  },
  {
    name: "account-register___fr",
    path: "register",
    component: () => import("/vercel/path0/pages/account/register.vue")
  },
  {
    name: "account-orders-id___fr",
    path: "orders/:id()",
    component: () => import("/vercel/path0/pages/account/orders/[id].vue")
  },
  {
    name: "account-verifyEmail___fr",
    path: "verifyEmail",
    component: () => import("/vercel/path0/pages/account/verifyEmail.vue")
  },
  {
    name: "account-orders___fr",
    path: "orders",
    meta: indexEN7UYhqJJNXclle_q__VPMBQKZZ_45XwL0cMSTDmGvLi4Meta || {},
    component: () => import("/vercel/path0/pages/account/orders/index.vue")
  },
  {
    name: "account-courses___fr",
    path: "courses",
    meta: indexb3R29QQT1_458_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta || {},
    component: () => import("/vercel/path0/pages/account/courses/index.vue")
  },
  {
    name: "account-passwordReset___fr",
    path: "passwordReset",
    component: () => import("/vercel/path0/pages/account/passwordReset.vue")
  },
  {
    name: "account-exercises___fr",
    path: "exercises",
    component: () => import("/vercel/path0/pages/account/exercises/index.vue")
  },
  {
    name: "account-profile-details___fr",
    path: "profile/details",
    component: () => import("/vercel/path0/pages/account/profile/details.vue")
  },
  {
    name: "account-profile-addresses___fr",
    path: "profile/addresses",
    meta: addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_45GNqbPBrwgMMeta || {},
    component: () => import("/vercel/path0/pages/account/profile/addresses.vue")
  },
  {
    name: "account-exercises-workouts___fr",
    path: "exercises/workouts",
    component: () => import("/vercel/path0/pages/account/exercises/workouts.vue")
  },
  {
    name: "account-exercises-premium___fr",
    path: "exercises/premium",
    component: () => import("/vercel/path0/pages/account/exercises/premium/index.vue")
  },
  {
    name: "account-exercises-premium-slug___fr",
    path: "exercises/premium/:slug()",
    component: () => import("/vercel/path0/pages/account/exercises/premium/[slug].vue")
  }
]
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta || {},
    component: () => import("/vercel/path0/pages/account.vue"),
    children: [
  {
    name: "account-login___nl",
    path: "login",
    component: () => import("/vercel/path0/pages/account/login.vue")
  },
  {
    name: "account-reset___nl",
    path: "reset",
    component: () => import("/vercel/path0/pages/account/reset.vue")
  },
  {
    name: "account-register___nl",
    path: "register",
    component: () => import("/vercel/path0/pages/account/register.vue")
  },
  {
    name: "account-orders-id___nl",
    path: "orders/:id()",
    component: () => import("/vercel/path0/pages/account/orders/[id].vue")
  },
  {
    name: "account-verifyEmail___nl",
    path: "verifyEmail",
    component: () => import("/vercel/path0/pages/account/verifyEmail.vue")
  },
  {
    name: "account-orders___nl",
    path: "orders",
    meta: indexEN7UYhqJJNXclle_q__VPMBQKZZ_45XwL0cMSTDmGvLi4Meta || {},
    component: () => import("/vercel/path0/pages/account/orders/index.vue")
  },
  {
    name: "account-courses___nl",
    path: "courses",
    meta: indexb3R29QQT1_458_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta || {},
    component: () => import("/vercel/path0/pages/account/courses/index.vue")
  },
  {
    name: "account-passwordReset___nl",
    path: "passwordReset",
    component: () => import("/vercel/path0/pages/account/passwordReset.vue")
  },
  {
    name: "account-exercises___nl",
    path: "exercises",
    component: () => import("/vercel/path0/pages/account/exercises/index.vue")
  },
  {
    name: "account-profile-details___nl",
    path: "profile/details",
    component: () => import("/vercel/path0/pages/account/profile/details.vue")
  },
  {
    name: "account-profile-addresses___nl",
    path: "profile/addresses",
    meta: addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_45GNqbPBrwgMMeta || {},
    component: () => import("/vercel/path0/pages/account/profile/addresses.vue")
  },
  {
    name: "account-exercises-workouts___nl",
    path: "exercises/workouts",
    component: () => import("/vercel/path0/pages/account/exercises/workouts.vue")
  },
  {
    name: "account-exercises-premium___nl",
    path: "exercises/premium",
    component: () => import("/vercel/path0/pages/account/exercises/premium/index.vue")
  },
  {
    name: "account-exercises-premium-slug___nl",
    path: "exercises/premium/:slug()",
    component: () => import("/vercel/path0/pages/account/exercises/premium/[slug].vue")
  }
]
  },
  {
    name: "account___ch-de",
    path: "/ch-de/account",
    meta: account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta || {},
    component: () => import("/vercel/path0/pages/account.vue"),
    children: [
  {
    name: "account-login___ch-de",
    path: "login",
    component: () => import("/vercel/path0/pages/account/login.vue")
  },
  {
    name: "account-reset___ch-de",
    path: "reset",
    component: () => import("/vercel/path0/pages/account/reset.vue")
  },
  {
    name: "account-register___ch-de",
    path: "register",
    component: () => import("/vercel/path0/pages/account/register.vue")
  },
  {
    name: "account-orders-id___ch-de",
    path: "orders/:id()",
    component: () => import("/vercel/path0/pages/account/orders/[id].vue")
  },
  {
    name: "account-verifyEmail___ch-de",
    path: "verifyEmail",
    component: () => import("/vercel/path0/pages/account/verifyEmail.vue")
  },
  {
    name: "account-orders___ch-de",
    path: "orders",
    meta: indexEN7UYhqJJNXclle_q__VPMBQKZZ_45XwL0cMSTDmGvLi4Meta || {},
    component: () => import("/vercel/path0/pages/account/orders/index.vue")
  },
  {
    name: "account-courses___ch-de",
    path: "courses",
    meta: indexb3R29QQT1_458_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta || {},
    component: () => import("/vercel/path0/pages/account/courses/index.vue")
  },
  {
    name: "account-passwordReset___ch-de",
    path: "passwordReset",
    component: () => import("/vercel/path0/pages/account/passwordReset.vue")
  },
  {
    name: "account-exercises___ch-de",
    path: "exercises",
    component: () => import("/vercel/path0/pages/account/exercises/index.vue")
  },
  {
    name: "account-profile-details___ch-de",
    path: "profile/details",
    component: () => import("/vercel/path0/pages/account/profile/details.vue")
  },
  {
    name: "account-profile-addresses___ch-de",
    path: "profile/addresses",
    meta: addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_45GNqbPBrwgMMeta || {},
    component: () => import("/vercel/path0/pages/account/profile/addresses.vue")
  },
  {
    name: "account-exercises-workouts___ch-de",
    path: "exercises/workouts",
    component: () => import("/vercel/path0/pages/account/exercises/workouts.vue")
  },
  {
    name: "account-exercises-premium___ch-de",
    path: "exercises/premium",
    component: () => import("/vercel/path0/pages/account/exercises/premium/index.vue")
  },
  {
    name: "account-exercises-premium-slug___ch-de",
    path: "exercises/premium/:slug()",
    component: () => import("/vercel/path0/pages/account/exercises/premium/[slug].vue")
  }
]
  },
  {
    name: "account___ch-fr",
    path: "/ch-fr/account",
    meta: account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta || {},
    component: () => import("/vercel/path0/pages/account.vue"),
    children: [
  {
    name: "account-login___ch-fr",
    path: "login",
    component: () => import("/vercel/path0/pages/account/login.vue")
  },
  {
    name: "account-reset___ch-fr",
    path: "reset",
    component: () => import("/vercel/path0/pages/account/reset.vue")
  },
  {
    name: "account-register___ch-fr",
    path: "register",
    component: () => import("/vercel/path0/pages/account/register.vue")
  },
  {
    name: "account-orders-id___ch-fr",
    path: "orders/:id()",
    component: () => import("/vercel/path0/pages/account/orders/[id].vue")
  },
  {
    name: "account-verifyEmail___ch-fr",
    path: "verifyEmail",
    component: () => import("/vercel/path0/pages/account/verifyEmail.vue")
  },
  {
    name: "account-orders___ch-fr",
    path: "orders",
    meta: indexEN7UYhqJJNXclle_q__VPMBQKZZ_45XwL0cMSTDmGvLi4Meta || {},
    component: () => import("/vercel/path0/pages/account/orders/index.vue")
  },
  {
    name: "account-courses___ch-fr",
    path: "courses",
    meta: indexb3R29QQT1_458_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta || {},
    component: () => import("/vercel/path0/pages/account/courses/index.vue")
  },
  {
    name: "account-passwordReset___ch-fr",
    path: "passwordReset",
    component: () => import("/vercel/path0/pages/account/passwordReset.vue")
  },
  {
    name: "account-exercises___ch-fr",
    path: "exercises",
    component: () => import("/vercel/path0/pages/account/exercises/index.vue")
  },
  {
    name: "account-profile-details___ch-fr",
    path: "profile/details",
    component: () => import("/vercel/path0/pages/account/profile/details.vue")
  },
  {
    name: "account-profile-addresses___ch-fr",
    path: "profile/addresses",
    meta: addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_45GNqbPBrwgMMeta || {},
    component: () => import("/vercel/path0/pages/account/profile/addresses.vue")
  },
  {
    name: "account-exercises-workouts___ch-fr",
    path: "exercises/workouts",
    component: () => import("/vercel/path0/pages/account/exercises/workouts.vue")
  },
  {
    name: "account-exercises-premium___ch-fr",
    path: "exercises/premium",
    component: () => import("/vercel/path0/pages/account/exercises/premium/index.vue")
  },
  {
    name: "account-exercises-premium-slug___ch-fr",
    path: "exercises/premium/:slug()",
    component: () => import("/vercel/path0/pages/account/exercises/premium/[slug].vue")
  }
]
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "slug___ch-de",
    path: "/ch-de/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "slug___ch-fr",
    path: "/ch-fr/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "processing___en",
    path: "/processing",
    component: () => import("/vercel/path0/pages/processing.vue")
  },
  {
    name: "processing___de",
    path: "/de/processing",
    component: () => import("/vercel/path0/pages/processing.vue")
  },
  {
    name: "processing___fr",
    path: "/fr/processing",
    component: () => import("/vercel/path0/pages/processing.vue")
  },
  {
    name: "processing___nl",
    path: "/nl/processing",
    component: () => import("/vercel/path0/pages/processing.vue")
  },
  {
    name: "processing___ch-de",
    path: "/ch-de/processing",
    component: () => import("/vercel/path0/pages/processing.vue")
  },
  {
    name: "processing___ch-fr",
    path: "/ch-fr/processing",
    component: () => import("/vercel/path0/pages/processing.vue")
  },
  {
    name: "shop___en",
    path: "/shop",
    component: () => import("/vercel/path0/pages/shop/index.vue")
  },
  {
    name: "shop___de",
    path: "/de/shop",
    component: () => import("/vercel/path0/pages/shop/index.vue")
  },
  {
    name: "shop___fr",
    path: "/fr/shop",
    component: () => import("/vercel/path0/pages/shop/index.vue")
  },
  {
    name: "shop___nl",
    path: "/nl/shop",
    component: () => import("/vercel/path0/pages/shop/index.vue")
  },
  {
    name: "shop___ch-de",
    path: "/ch-de/shop",
    component: () => import("/vercel/path0/pages/shop/index.vue")
  },
  {
    name: "shop___ch-fr",
    path: "/ch-fr/shop",
    component: () => import("/vercel/path0/pages/shop/index.vue")
  },
  {
    name: "about___en",
    path: "/about-blackroll",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "about___de",
    path: "/de/ueber-blackroll",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "about___fr",
    path: "/fr/a-propos-de-blackroll",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "about___nl",
    path: "/nl/over-blackroll",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "about___ch-de",
    path: "/ch-de/ueber-blackroll",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "about___ch-fr",
    path: "/ch-fr/a-propos-de-blackroll",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "about-slug___en",
    path: "/about-blackroll/:slug()",
    component: () => import("/vercel/path0/pages/about/[slug].vue")
  },
  {
    name: "about-slug___de",
    path: "/de/ueber-blackroll/:slug()",
    component: () => import("/vercel/path0/pages/about/[slug].vue")
  },
  {
    name: "about-slug___fr",
    path: "/fr/a-propos-de-blackroll/:slug()",
    component: () => import("/vercel/path0/pages/about/[slug].vue")
  },
  {
    name: "about-slug___nl",
    path: "/nl/over-blackroll/:slug()",
    component: () => import("/vercel/path0/pages/about/[slug].vue")
  },
  {
    name: "about-slug___ch-de",
    path: "/ch-de/ueber-blackroll/:slug()",
    component: () => import("/vercel/path0/pages/about/[slug].vue")
  },
  {
    name: "about-slug___ch-fr",
    path: "/ch-fr/a-propos-de-blackroll/:slug()",
    component: () => import("/vercel/path0/pages/about/[slug].vue")
  },
  {
    name: "story-slug___en",
    path: "/story/:slug()",
    component: () => import("/vercel/path0/pages/story/[slug].vue")
  },
  {
    name: "story-slug___de",
    path: "/de/story/:slug()",
    component: () => import("/vercel/path0/pages/story/[slug].vue")
  },
  {
    name: "story-slug___fr",
    path: "/fr/story/:slug()",
    component: () => import("/vercel/path0/pages/story/[slug].vue")
  },
  {
    name: "story-slug___nl",
    path: "/nl/story/:slug()",
    component: () => import("/vercel/path0/pages/story/[slug].vue")
  },
  {
    name: "story-slug___ch-de",
    path: "/ch-de/story/:slug()",
    component: () => import("/vercel/path0/pages/story/[slug].vue")
  },
  {
    name: "story-slug___ch-fr",
    path: "/ch-fr/story/:slug()",
    component: () => import("/vercel/path0/pages/story/[slug].vue")
  },
  {
    name: "academy___en",
    path: "/academy",
    component: () => import("/vercel/path0/pages/academy/index.vue")
  },
  {
    name: "academy___de",
    path: "/de/academy",
    component: () => import("/vercel/path0/pages/academy/index.vue")
  },
  {
    name: "academy___fr",
    path: "/fr/academy",
    component: () => import("/vercel/path0/pages/academy/index.vue")
  },
  {
    name: "academy___nl",
    path: "/nl/academy",
    component: () => import("/vercel/path0/pages/academy/index.vue")
  },
  {
    name: "academy___ch-de",
    path: "/ch-de/academy",
    component: () => import("/vercel/path0/pages/academy/index.vue")
  },
  {
    name: "academy___ch-fr",
    path: "/ch-fr/academy",
    component: () => import("/vercel/path0/pages/academy/index.vue")
  },
  {
    name: "experts___en",
    path: "/experts",
    component: () => import("/vercel/path0/pages/experts/index.vue")
  },
  {
    name: "experts___de",
    path: "/de/experten",
    component: () => import("/vercel/path0/pages/experts/index.vue")
  },
  {
    name: "experts___fr",
    path: "/fr/experts",
    component: () => import("/vercel/path0/pages/experts/index.vue")
  },
  {
    name: "experts___nl",
    path: "/nl/onze-experts",
    component: () => import("/vercel/path0/pages/experts/index.vue")
  },
  {
    name: "experts___ch-de",
    path: "/ch-de/experten",
    component: () => import("/vercel/path0/pages/experts/index.vue")
  },
  {
    name: "experts___ch-fr",
    path: "/ch-fr/experts",
    component: () => import("/vercel/path0/pages/experts/index.vue")
  },
  {
    name: "returns___en",
    path: "/returns",
    component: () => import("/vercel/path0/pages/returns/index.vue")
  },
  {
    name: "returns___de",
    path: "/de/ruecksendungen",
    component: () => import("/vercel/path0/pages/returns/index.vue")
  },
  {
    name: "returns___fr",
    path: "/fr/retours",
    component: () => import("/vercel/path0/pages/returns/index.vue")
  },
  {
    name: "returns___nl",
    path: "/nl/retourneert",
    component: () => import("/vercel/path0/pages/returns/index.vue")
  },
  {
    name: "returns___ch-de",
    path: "/ch-de/ruecksendungen",
    component: () => import("/vercel/path0/pages/returns/index.vue")
  },
  {
    name: "returns___ch-fr",
    path: "/ch-fr/retours",
    component: () => import("/vercel/path0/pages/returns/index.vue")
  },
  {
    name: "returns-label___en",
    path: "/returns/label",
    component: () => import("/vercel/path0/pages/returns/label.vue")
  },
  {
    name: "returns-label___de",
    path: "/de/ruecksendungen/label",
    component: () => import("/vercel/path0/pages/returns/label.vue")
  },
  {
    name: "returns-label___fr",
    path: "/fr/retours/label",
    component: () => import("/vercel/path0/pages/returns/label.vue")
  },
  {
    name: "returns-label___nl",
    path: "/nl/retourneert/label",
    component: () => import("/vercel/path0/pages/returns/label.vue")
  },
  {
    name: "returns-label___ch-de",
    path: "/ch-de/ruecksendungen/label",
    component: () => import("/vercel/path0/pages/returns/label.vue")
  },
  {
    name: "returns-label___ch-fr",
    path: "/ch-fr/retours/label",
    component: () => import("/vercel/path0/pages/returns/label.vue")
  },
  {
    name: "returns-order___en",
    path: "/returns/order",
    component: () => import("/vercel/path0/pages/returns/order.vue")
  },
  {
    name: "returns-order___de",
    path: "/de/ruecksendungen/order",
    component: () => import("/vercel/path0/pages/returns/order.vue")
  },
  {
    name: "returns-order___fr",
    path: "/fr/retours/order",
    component: () => import("/vercel/path0/pages/returns/order.vue")
  },
  {
    name: "returns-order___nl",
    path: "/nl/retourneert/order",
    component: () => import("/vercel/path0/pages/returns/order.vue")
  },
  {
    name: "returns-order___ch-de",
    path: "/ch-de/ruecksendungen/order",
    component: () => import("/vercel/path0/pages/returns/order.vue")
  },
  {
    name: "returns-order___ch-fr",
    path: "/ch-fr/retours/order",
    component: () => import("/vercel/path0/pages/returns/order.vue")
  },
  {
    name: "stories___en",
    path: "/stories",
    component: () => import("/vercel/path0/pages/stories/index.vue")
  },
  {
    name: "stories___de",
    path: "/de/stories",
    component: () => import("/vercel/path0/pages/stories/index.vue")
  },
  {
    name: "stories___fr",
    path: "/fr/stories",
    component: () => import("/vercel/path0/pages/stories/index.vue")
  },
  {
    name: "stories___nl",
    path: "/nl/stories",
    component: () => import("/vercel/path0/pages/stories/index.vue")
  },
  {
    name: "stories___ch-de",
    path: "/ch-de/stories",
    component: () => import("/vercel/path0/pages/stories/index.vue")
  },
  {
    name: "stories___ch-fr",
    path: "/ch-fr/stories",
    component: () => import("/vercel/path0/pages/stories/index.vue")
  },
  {
    name: "routine-slug___en",
    path: "/routine/:slug()",
    component: () => import("/vercel/path0/pages/routine/[slug].vue")
  },
  {
    name: "routine-slug___de",
    path: "/de/routine/:slug()",
    component: () => import("/vercel/path0/pages/routine/[slug].vue")
  },
  {
    name: "routine-slug___fr",
    path: "/fr/routine/:slug()",
    component: () => import("/vercel/path0/pages/routine/[slug].vue")
  },
  {
    name: "routine-slug___nl",
    path: "/nl/routine/:slug()",
    component: () => import("/vercel/path0/pages/routine/[slug].vue")
  },
  {
    name: "routine-slug___ch-de",
    path: "/ch-de/routine/:slug()",
    component: () => import("/vercel/path0/pages/routine/[slug].vue")
  },
  {
    name: "routine-slug___ch-fr",
    path: "/ch-fr/routine/:slug()",
    component: () => import("/vercel/path0/pages/routine/[slug].vue")
  },
  {
    name: "stories-slug___en",
    path: "/stories/:slug()",
    component: () => import("/vercel/path0/pages/stories/[slug].vue")
  },
  {
    name: "stories-slug___de",
    path: "/de/stories/:slug()",
    component: () => import("/vercel/path0/pages/stories/[slug].vue")
  },
  {
    name: "stories-slug___fr",
    path: "/fr/stories/:slug()",
    component: () => import("/vercel/path0/pages/stories/[slug].vue")
  },
  {
    name: "stories-slug___nl",
    path: "/nl/stories/:slug()",
    component: () => import("/vercel/path0/pages/stories/[slug].vue")
  },
  {
    name: "stories-slug___ch-de",
    path: "/ch-de/stories/:slug()",
    component: () => import("/vercel/path0/pages/stories/[slug].vue")
  },
  {
    name: "stories-slug___ch-fr",
    path: "/ch-fr/stories/:slug()",
    component: () => import("/vercel/path0/pages/stories/[slug].vue")
  },
  {
    name: indexer6HU_HqrwSxRZpFVbIPTgveLDAY_45GxXiOdCB3_z2N4Meta?.name,
    path: "/knowledge",
    component: () => import("/vercel/path0/pages/knowledge/index.vue"),
    children: [
  {
    name: "knowledge-index___en",
    path: "",
    component: () => import("/vercel/path0/pages/knowledge/index/index.vue")
  },
  {
    name: "knowledge-index-topic___en",
    path: ":topic()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/index.vue")
  },
  {
    name: "knowledge-index-category-slug___en",
    path: "category/:slug()",
    component: () => import("/vercel/path0/pages/knowledge/index/category/[slug].vue")
  },
  {
    name: "knowledge-index-topic-articles___en",
    path: ":topic()/articles",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/articles.vue")
  },
  {
    name: "knowledge-index-topic-category___en",
    path: ":topic()/:category()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/[category].vue")
  }
]
  },
  {
    name: indexer6HU_HqrwSxRZpFVbIPTgveLDAY_45GxXiOdCB3_z2N4Meta?.name,
    path: "/de/wissen",
    component: () => import("/vercel/path0/pages/knowledge/index.vue"),
    children: [
  {
    name: "knowledge-index___de",
    path: "",
    component: () => import("/vercel/path0/pages/knowledge/index/index.vue")
  },
  {
    name: "knowledge-index-topic___de",
    path: ":topic()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/index.vue")
  },
  {
    name: "knowledge-index-category-slug___de",
    path: "category/:slug()",
    component: () => import("/vercel/path0/pages/knowledge/index/category/[slug].vue")
  },
  {
    name: "knowledge-index-topic-articles___de",
    path: ":topic()/articles",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/articles.vue")
  },
  {
    name: "knowledge-index-topic-category___de",
    path: ":topic()/:category()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/[category].vue")
  }
]
  },
  {
    name: indexer6HU_HqrwSxRZpFVbIPTgveLDAY_45GxXiOdCB3_z2N4Meta?.name,
    path: "/fr/connaissances",
    component: () => import("/vercel/path0/pages/knowledge/index.vue"),
    children: [
  {
    name: "knowledge-index___fr",
    path: "",
    component: () => import("/vercel/path0/pages/knowledge/index/index.vue")
  },
  {
    name: "knowledge-index-topic___fr",
    path: ":topic()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/index.vue")
  },
  {
    name: "knowledge-index-category-slug___fr",
    path: "category/:slug()",
    component: () => import("/vercel/path0/pages/knowledge/index/category/[slug].vue")
  },
  {
    name: "knowledge-index-topic-articles___fr",
    path: ":topic()/articles",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/articles.vue")
  },
  {
    name: "knowledge-index-topic-category___fr",
    path: ":topic()/:category()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/[category].vue")
  }
]
  },
  {
    name: indexer6HU_HqrwSxRZpFVbIPTgveLDAY_45GxXiOdCB3_z2N4Meta?.name,
    path: "/nl/kennis",
    component: () => import("/vercel/path0/pages/knowledge/index.vue"),
    children: [
  {
    name: "knowledge-index___nl",
    path: "",
    component: () => import("/vercel/path0/pages/knowledge/index/index.vue")
  },
  {
    name: "knowledge-index-topic___nl",
    path: ":topic()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/index.vue")
  },
  {
    name: "knowledge-index-category-slug___nl",
    path: "category/:slug()",
    component: () => import("/vercel/path0/pages/knowledge/index/category/[slug].vue")
  },
  {
    name: "knowledge-index-topic-articles___nl",
    path: ":topic()/articles",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/articles.vue")
  },
  {
    name: "knowledge-index-topic-category___nl",
    path: ":topic()/:category()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/[category].vue")
  }
]
  },
  {
    name: indexer6HU_HqrwSxRZpFVbIPTgveLDAY_45GxXiOdCB3_z2N4Meta?.name,
    path: "/ch-de/wissen",
    component: () => import("/vercel/path0/pages/knowledge/index.vue"),
    children: [
  {
    name: "knowledge-index___ch-de",
    path: "",
    component: () => import("/vercel/path0/pages/knowledge/index/index.vue")
  },
  {
    name: "knowledge-index-topic___ch-de",
    path: ":topic()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/index.vue")
  },
  {
    name: "knowledge-index-category-slug___ch-de",
    path: "category/:slug()",
    component: () => import("/vercel/path0/pages/knowledge/index/category/[slug].vue")
  },
  {
    name: "knowledge-index-topic-articles___ch-de",
    path: ":topic()/articles",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/articles.vue")
  },
  {
    name: "knowledge-index-topic-category___ch-de",
    path: ":topic()/:category()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/[category].vue")
  }
]
  },
  {
    name: indexer6HU_HqrwSxRZpFVbIPTgveLDAY_45GxXiOdCB3_z2N4Meta?.name,
    path: "/ch-fr/connaissances",
    component: () => import("/vercel/path0/pages/knowledge/index.vue"),
    children: [
  {
    name: "knowledge-index___ch-fr",
    path: "",
    component: () => import("/vercel/path0/pages/knowledge/index/index.vue")
  },
  {
    name: "knowledge-index-topic___ch-fr",
    path: ":topic()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/index.vue")
  },
  {
    name: "knowledge-index-category-slug___ch-fr",
    path: "category/:slug()",
    component: () => import("/vercel/path0/pages/knowledge/index/category/[slug].vue")
  },
  {
    name: "knowledge-index-topic-articles___ch-fr",
    path: ":topic()/articles",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/articles.vue")
  },
  {
    name: "knowledge-index-topic-category___ch-fr",
    path: ":topic()/:category()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/[category].vue")
  }
]
  },
  {
    name: "products-slug___en",
    path: "/products/:slug()",
    component: () => import("/vercel/path0/pages/products/[slug].vue")
  },
  {
    name: "products-slug___de",
    path: "/de/products/:slug()",
    component: () => import("/vercel/path0/pages/products/[slug].vue")
  },
  {
    name: "products-slug___fr",
    path: "/fr/products/:slug()",
    component: () => import("/vercel/path0/pages/products/[slug].vue")
  },
  {
    name: "products-slug___nl",
    path: "/nl/products/:slug()",
    component: () => import("/vercel/path0/pages/products/[slug].vue")
  },
  {
    name: "products-slug___ch-de",
    path: "/ch-de/products/:slug()",
    component: () => import("/vercel/path0/pages/products/[slug].vue")
  },
  {
    name: "products-slug___ch-fr",
    path: "/ch-fr/products/:slug()",
    component: () => import("/vercel/path0/pages/products/[slug].vue")
  },
  {
    name: "academy-slug___en",
    path: "/academy/:slug(.*)*",
    component: () => import("/vercel/path0/pages/academy/[...slug].vue")
  },
  {
    name: "academy-slug___de",
    path: "/de/academy/:slug(.*)*",
    component: () => import("/vercel/path0/pages/academy/[...slug].vue")
  },
  {
    name: "academy-slug___fr",
    path: "/fr/academy/:slug(.*)*",
    component: () => import("/vercel/path0/pages/academy/[...slug].vue")
  },
  {
    name: "academy-slug___nl",
    path: "/nl/academy/:slug(.*)*",
    component: () => import("/vercel/path0/pages/academy/[...slug].vue")
  },
  {
    name: "academy-slug___ch-de",
    path: "/ch-de/academy/:slug(.*)*",
    component: () => import("/vercel/path0/pages/academy/[...slug].vue")
  },
  {
    name: "academy-slug___ch-fr",
    path: "/ch-fr/academy/:slug(.*)*",
    component: () => import("/vercel/path0/pages/academy/[...slug].vue")
  },
  {
    name: "service-slug___en",
    path: "/service/:slug(.*)*",
    component: () => import("/vercel/path0/pages/service/[...slug].vue")
  },
  {
    name: "service-slug___de",
    path: "/de/service/:slug(.*)*",
    component: () => import("/vercel/path0/pages/service/[...slug].vue")
  },
  {
    name: "service-slug___fr",
    path: "/fr/service/:slug(.*)*",
    component: () => import("/vercel/path0/pages/service/[...slug].vue")
  },
  {
    name: "service-slug___nl",
    path: "/nl/service/:slug(.*)*",
    component: () => import("/vercel/path0/pages/service/[...slug].vue")
  },
  {
    name: "service-slug___ch-de",
    path: "/ch-de/service/:slug(.*)*",
    component: () => import("/vercel/path0/pages/service/[...slug].vue")
  },
  {
    name: "service-slug___ch-fr",
    path: "/ch-fr/service/:slug(.*)*",
    component: () => import("/vercel/path0/pages/service/[...slug].vue")
  },
  {
    name: "shop-slug___en",
    path: "/shop/:slug()",
    component: () => import("/vercel/path0/pages/shop/[slug]/index.vue")
  },
  {
    name: "shop-slug___de",
    path: "/de/shop/:slug()",
    component: () => import("/vercel/path0/pages/shop/[slug]/index.vue")
  },
  {
    name: "shop-slug___fr",
    path: "/fr/shop/:slug()",
    component: () => import("/vercel/path0/pages/shop/[slug]/index.vue")
  },
  {
    name: "shop-slug___nl",
    path: "/nl/shop/:slug()",
    component: () => import("/vercel/path0/pages/shop/[slug]/index.vue")
  },
  {
    name: "shop-slug___ch-de",
    path: "/ch-de/shop/:slug()",
    component: () => import("/vercel/path0/pages/shop/[slug]/index.vue")
  },
  {
    name: "shop-slug___ch-fr",
    path: "/ch-fr/shop/:slug()",
    component: () => import("/vercel/path0/pages/shop/[slug]/index.vue")
  },
  {
    name: "exercises-slug___en",
    path: "/exercises/:slug(.*)*",
    component: () => import("/vercel/path0/pages/exercises/[...slug].vue")
  },
  {
    name: "exercises-slug___de",
    path: "/de/uebungen/:slug(.*)*",
    component: () => import("/vercel/path0/pages/exercises/[...slug].vue")
  },
  {
    name: "exercises-slug___fr",
    path: "/fr/exercices/:slug(.*)*",
    component: () => import("/vercel/path0/pages/exercises/[...slug].vue")
  },
  {
    name: "exercises-slug___nl",
    path: "/nl/oefeningen/:slug(.*)*",
    component: () => import("/vercel/path0/pages/exercises/[...slug].vue")
  },
  {
    name: "exercises-slug___ch-de",
    path: "/ch-de/uebungen/:slug(.*)*",
    component: () => import("/vercel/path0/pages/exercises/[...slug].vue")
  },
  {
    name: "exercises-slug___ch-fr",
    path: "/ch-fr/exercices/:slug(.*)*",
    component: () => import("/vercel/path0/pages/exercises/[...slug].vue")
  },
  {
    name: "article-slug___en",
    path: "/article/:slug()",
    component: () => import("/vercel/path0/pages/article/[slug]/index.vue")
  },
  {
    name: "article-slug___de",
    path: "/de/artikel/:slug()",
    component: () => import("/vercel/path0/pages/article/[slug]/index.vue")
  },
  {
    name: "article-slug___fr",
    path: "/fr/article/:slug()",
    component: () => import("/vercel/path0/pages/article/[slug]/index.vue")
  },
  {
    name: "article-slug___nl",
    path: "/nl/article/:slug()",
    component: () => import("/vercel/path0/pages/article/[slug]/index.vue")
  },
  {
    name: "article-slug___ch-de",
    path: "/ch-de/artikel/:slug()",
    component: () => import("/vercel/path0/pages/article/[slug]/index.vue")
  },
  {
    name: "article-slug___ch-fr",
    path: "/ch-fr/article/:slug()",
    component: () => import("/vercel/path0/pages/article/[slug]/index.vue")
  },
  {
    name: "experts-slug___en",
    path: "/experts/:slug()",
    component: () => import("/vercel/path0/pages/experts/[slug]/index.vue")
  },
  {
    name: "experts-slug___de",
    path: "/de/experten/:slug()",
    component: () => import("/vercel/path0/pages/experts/[slug]/index.vue")
  },
  {
    name: "experts-slug___fr",
    path: "/fr/experts/:slug()",
    component: () => import("/vercel/path0/pages/experts/[slug]/index.vue")
  },
  {
    name: "experts-slug___nl",
    path: "/nl/onze-experts/:slug()",
    component: () => import("/vercel/path0/pages/experts/[slug]/index.vue")
  },
  {
    name: "experts-slug___ch-de",
    path: "/ch-de/experten/:slug()",
    component: () => import("/vercel/path0/pages/experts/[slug]/index.vue")
  },
  {
    name: "experts-slug___ch-fr",
    path: "/ch-fr/experts/:slug()",
    component: () => import("/vercel/path0/pages/experts/[slug]/index.vue")
  },
  {
    name: "collections-handle___en",
    path: "/collections/:handle()",
    component: () => import("/vercel/path0/pages/collections/[handle]/index.vue")
  },
  {
    name: "collections-handle___de",
    path: "/de/collections/:handle()",
    component: () => import("/vercel/path0/pages/collections/[handle]/index.vue")
  },
  {
    name: "collections-handle___fr",
    path: "/fr/collections/:handle()",
    component: () => import("/vercel/path0/pages/collections/[handle]/index.vue")
  },
  {
    name: "collections-handle___nl",
    path: "/nl/collections/:handle()",
    component: () => import("/vercel/path0/pages/collections/[handle]/index.vue")
  },
  {
    name: "collections-handle___ch-de",
    path: "/ch-de/collections/:handle()",
    component: () => import("/vercel/path0/pages/collections/[handle]/index.vue")
  },
  {
    name: "collections-handle___ch-fr",
    path: "/ch-fr/collections/:handle()",
    component: () => import("/vercel/path0/pages/collections/[handle]/index.vue")
  }
]